import { useState } from "react";
import { getActiveCountry, ISO_COUNTRY_META, setLocaleOverride } from "../../lib/locale";

export function LocationCTA() {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const active = getActiveCountry();

  const handleSelect = (code: string | null) => {
    setLocaleOverride(code);
    setOpen(false);
    // Force re-render of location-aware components
    window.dispatchEvent(new Event("sloe_locale_changed"));
  };

  const countries = Object.entries(ISO_COUNTRY_META).map(([code, meta]) => ({
    code,
    ...meta,
  }));

  const filtered = countries.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.code.toLowerCase().includes(search.toLowerCase()) ||
      c.currency.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1 text-xs font-medium text-slate-700 shadow-sm hover:bg-slate-50 transition-colors"
      >
        <span>{active ? active.flag : "🌐"}</span>
        <span>{active ? active.name : "USD ($)"}</span>
        <span className="text-[10px] text-slate-400">▼</span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-1 w-64 rounded-xl border border-slate-200 bg-white p-2 shadow-lg">
          <input
            type="text"
            placeholder="Search country or currency..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mb-2 w-full rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-indigo-500"
          />
          <div className="max-h-48 overflow-y-auto space-y-0.5">
            <button
              type="button"
              onClick={() => handleSelect("NONE")}
              className="w-full text-left px-2 py-1.5 text-xs text-slate-600 hover:bg-slate-50 rounded-md flex items-center justify-between"
            >
              <span>Not listed — show USD</span>
              {active === null && <span className="text-indigo-600 font-bold">✓</span>}
            </button>
            {filtered.map((c) => (
              <button
                key={c.code}
                type="button"
                onClick={() => handleSelect(c.code)}
                className="w-full text-left px-2 py-1.5 text-xs text-slate-800 hover:bg-slate-50 rounded-md flex items-center justify-between"
              >
                <span className="flex items-center gap-2">
                  <span>{c.flag}</span>
                  <span>{c.name}</span>
                </span>
                <span className="text-[11px] text-slate-400">{c.currency}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
